import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import {
  employmentRelationshipDefinition,
  employmentRelationshipHandler,
} from './employmentRelationship';

export const multiEmploymentRelationshipDefinition: FilterDefinition<
  MultiFilter<ListFilter>
> = {
  id: FilterId.MULTI_EMPLOYMENT_RELATIONSHIP,
  name: 'Employment Type',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.EMPLOYMENT_RELATIONSHIP,
  instances: [],
  isVisible: true,
};

export const multiEmploymentRelationshipHandler: FilterHandler<
  MultiFilter<ListFilter>
> = {
  isActive(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.some((instance) =>
      employmentRelationshipHandler.isActive(instance)
    );
  },

  isDefault(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      employmentRelationshipHandler.getEffectiveFilter(
        instance,
        employmentRelationshipDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
